export default __webpack_public_path__ + "static/media/portfolio-nexx-3.5eb58c49.jpg";